import { Icon, PaletteColor, useFormatDate } from "@dgs/core";
import { isAfter, parse } from "date-fns";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	deletionDate: string;
	eventEnd: string;
}

const Warning = styled.span`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(1)};
	${Icon} {
		width: 18px;
		height: 18px;
	}
`;
const StyledIcon = styled(Icon)<{ $color: PaletteColor }>`
	color: ${({ $color, theme }) => theme.colors.palette[$color].main.base};
`;

export const HostingDuration: FC<Props> = ({ deletionDate, eventEnd }) => {
	const { t } = useTranslation();
	const formatDate = useFormatDate();
	const appIsAboutToBeDeleted = isAfter(new Date(), parse(deletionDate, "yyyy-MM-dd", new Date()));
	const hostingExpiresBeforeEventEnd = isAfter(
		parse(eventEnd, "yyyy-MM-dd", new Date()),
		parse(deletionDate, "yyyy-MM-dd", new Date()),
	);

	return (
		<Warning>
			{`${t("Hosting until")}: ${formatDate(deletionDate)}`}
			{hostingExpiresBeforeEventEnd && (
				<StyledIcon
					$icon="alert"
					$color="danger"
					title={t("The application is deleted before the event has been executed.")}
				/>
			)}
			{appIsAboutToBeDeleted && (
				<StyledIcon
					$icon="warning"
					$color="warning"
					title={t("The application is in the process of being deleted because the hosting period has expired.")}
				/>
			)}
		</Warning>
	);
};
